import React from 'react'

import { connect } from 'react-redux'

import BasePureComponent from 'utils/BasePureComponent'
import Input from 'components/Input'

import './style.scss'

import {
  addExtraData,
  updateExtraData,
  deleteExtraData,
  resetState
} from 'components/PolicyForm/actions'


export class AdditionalData extends BasePureComponent {
  constructor(props) {
    super(props)

    this.state = {
      key: '',
      value: ''
    }

    this._bind('_renderExtra', '_onAdd', '_onDelete', '_onChange', '_onExtraChange')
  }

  componentDidMount() {
    const data = this.props.extraData
    if (data) {
      this.props.resetState()
      Object.entries(data).forEach(([key, value]) => {
        this.props.addExtra(value.key, value.value)
      });
    }
  }

  _renderExtra(extraId) {
    const extra = this.props.data.extra_data[extraId]

    return (
      <div key={extraId} className="PolicyDataStep__AdditionalData-row">
        <Input
          label="Campo"
          name={`${extraId}_key`}
          onChange={this._onExtraChange}
          value={extra.key} />
        <Input
          label="Valor"
          name={`${extraId}_value`}
          onChange={this._onExtraChange}
          value={extra.value} />
        <div className="button-wrapper">
          <button onClick={() => this._onDelete(extraId)} className="delete">
            <i className="material-icons">delete_forever</i>
          </button>
        </div>
      </div>
    )
  }

  _onExtraChange(evt) {
    const [uuid, type] = evt.target.name.split('_')
    this.props.updateExtra(uuid, evt.target.value, type === 'key')
  }

  _onDelete(id) {
    this.props.deleteExtra(id)
  }

  _onAdd(evt) {
    evt.preventDefault()

    if (!this.state.key || !this.state.value)
      return

    this.props.addExtra(this.state.key, this.state.value)
    this.setState({ key: '', value: '' })
  }

  _onChange(evt) {
    this.setState({ [evt.target.name]: evt.target.value })
  }

  render() {
    return (
      <div>
        {this.props.data.extra_data_order.map(this._renderExtra)}
        <div className="PolicyDataStep__AdditionalData-row">
          <Input
            label="Campo"
            name="key"
            onChange={this._onChange}
            value={this.state.key} />
          <Input
            label="Valor"
            name="value"
            onChange={this._onChange}
            value={this.state.value} />
          <div className="button-wrapper">
            <button onClick={this._onAdd}  className="add">
              <i className="material-icons">add</i> Agregar
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.policyForm.get('data').toJS()
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    deleteExtra: (id) => dispatch(deleteExtraData(id)),
    updateExtra: (uuid, inputValue, isKey) => dispatch(updateExtraData(uuid, inputValue, isKey)),
    addExtra: (key, value) => dispatch(addExtraData(key, value)),
    resetState: () => dispatch(resetState()),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(AdditionalData)



// WEBPACK FOOTER //
// ./src/components/PolicyForm/AdditionalData/index.js